import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from "ramda"

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_AUTH_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- login --------*/
  requestLogin: ["email", "password"],
  loginSuccess: ["loginResponse"],
  loginFailure: ["loginError"],
  requestLogout: null,
  requestEnableLoginModal: ["isLogin"],

  /*---------- userProfile --------*/
  requestUserProfile: [],
  userProfileSuccess: ["userProfileResponse"],
  userProfileFailure: ["userProfileError"],

  /*---------- externalLogin --------*/
  requestExternalLogin: ["data"],
  externalLoginSuccess: ["externalLoginResponse"],
  externalLoginFailure: ["externalLoginError"],

  /*---------- register --------*/
  requestRegister: ["data"],
  registerSuccess: ["registerResponse"],
  registerFailure: ["registerError"],

  /*---------- confirmEmail --------*/
  requestConfirmEmail: ["userId", "token"],
  confirmEmailSuccess: ["confirmEmailResponse"],
  confirmEmailFailure: ["confirmEmailError"],

  /*---------- updateUserProfile --------*/
  requestUpdateUserProfile: ["userProfile"],
  updateUserProfileSuccess: ["updateUserProfileResponse"],
  updateUserProfileFailure: ["updateUserProfileError"],
  requestClearUpdateUserProfileStatus: [],

  /*---------- resetUserPassword --------*/
  requestResetUserPassword: ["email"],
  resetUserPasswordSuccess: ["resetUserPasswordResponse"],
  resetUserPasswordFailure: ["resetUserPasswordError"],

  /*---------- confirmResetUserPassword --------*/
  requestConfirmResetUserPassword: ["confirmData"],
  confirmResetUserPasswordSuccess: ["confirmResetUserPasswordResponse"],
  confirmResetUserPasswordFailure: ["confirmResetUserPasswordError"],

  /*---------- customerRegister --------*/
  requestCustomerRegister: ["customerReq"],
  customerRegisterSuccess: ["customerRegisterResponse"],
  customerRegisterFailure: ["customerRegisterError"],

  /*---------- updateCustomerProfile --------*/
  requestUpdateCustomerProfile: ["customerProfileReq"],
  updateCustomerProfileSuccess: ["updateCustomerProfileResponse"],
  updateCustomerProfileFailure: ["updateCustomerProfileError"],

  /*---------- cookie --------*/
  requestSaveCookie: []
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaAuthReduxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const LOGOUT_STATE = {
  email: null,
  password: null,
  loginResponse: null,
  loginError: null,
  loginFetching: false,
  token: null,
  userProfileResponse: null,
  data: null,
  registerResponse: null,
  accountVisible: false
}

export const SagAuthInitState = { ...LOGOUT_STATE }

export const INITIAL_STATE = Immutable(SagAuthInitState)

/* ------------- Reducers ------------- */

/*---------- login --------*/
export const requestLogin = (state, action) => {
  return state.merge({
    loginFetching: true,
    email: action.email,
    password: action.password,
    loginResponse: null,
    loginError: null
  })
}
export const loginSuccess = (state, action) => {
  return state.merge({
    loginFetching: false,
    token: action.loginResponse,
    loginResponse: action.loginResponse,
    password: null
  })
}
export const loginFailure = (state, action) => {
  return state.merge({
    loginFetching: false,
    loginError: action.loginError,
    password: null
  })
}

export const requestLogout = state => {
  return state.merge(LOGOUT_STATE)
}

export const requestEnableLoginModal = (state, action) => {
  return state.merge({
    accountVisible: action.isLogin
  })
}

/*---------- userProfile --------*/
export const requestUserProfile = state => {
  return state.merge({
    userProfileFetching: true,
    userProfileResponse: null,
    userProfileError: null,
    updateUserProfileResponse: null,
    updateUserProfileError: null,
    password: null,
    updateCustomerProfileResponse: null,
    cookie: false
  })
}
export const userProfileSuccess = (state, action) => {
  return state.merge({
    userProfileFetching: false,
    userProfileResponse: action.userProfileResponse,
    password: null,
    updateCustomerProfileResponse: null
  })
}
export const userProfileFailure = (state, action) => {
  return state.merge({
    userProfileFetching: false,
    userProfileError: action.userProfileError,
    password: null
  })
}

/*---------- externalLogin --------*/
export const requestExternalLogin = (state, action) => {
  return state.merge({
    externalLoginFetching: true,
    data: action.data,
    loginResponse: null,
    loginError: null
  })
}
export const externalLoginSuccess = (state, action) => {
  return state.merge({
    externalLoginFetching: false,
    loginResponse: action.externalLoginResponse,
    token: action.externalLoginResponse,
    accountVisible: false
  })
}
export const externalLoginFailure = (state, action) => {
  return state.merge({
    externalLoginFetching: false,
    loginError: action.externalLoginError
  })
}

/*---------- register --------*/

export const requestRegister = (state, action) => {
  return state.merge({
    registerFetching: true,
    data: action.data,
    registerResponse: null,
    registerError: null
  })
}
export const registerSuccess = (state, action) => {
  return state.merge({
    registerFetching: false,
    registerResponse: action.registerResponse
    // accountVisible: false
  })
}
export const registerFailure = (state, action) => {
  return state.merge({
    registerFetching: false,
    registerError: action.registerError
  })
}

/*---------- confirmEmail --------*/
export const requestConfirmEmail = (state, action) => {
  return state.merge({
    confirmEmailFetching: true,
    userId: action.userId,
    token: action.token,
    confirmEmailResponse: null,
    confirmEmailError: null
  })
}
export const confirmEmailSuccess = (state, action) => {
  return state.merge({
    confirmEmailFetching: false,
    confirmEmailResponse: action.confirmEmailResponse
  })
}
export const confirmEmailFailure = (state, action) => {
  return state.merge({
    confirmEmailFetching: false,
    confirmEmailError: action.confirmEmailError
  })
}

/*---------- updateUserProfile --------*/

export const requestUpdateUserProfile = (state, action) => {
  return state.merge({
    updateUserProfileFetching: true,
    userProfile: action.userProfile
  })
}

export const requestClearUpdateUserProfileStatus = (state, action) => {
  return state.merge({
    updateUserProfileResponse: false
  })
}

export const updateUserProfileSuccess = (state: Immutable, action) => {
  return state.merge({
    updateUserProfileFetching: false,
    updateUserProfileResponse: action.updateUserProfileResponse,
    updateUserProfileError: null
  })
}
export const updateUserProfileFailure = (state: Immutable, action) => {
  return state.merge({
    updateUserProfileFetching: false,
    updateUserProfileError: action.updateUserProfileError
  })
}

/*---------- resetUserPassword --------*/
export const requestResetUserPassword = (state: Immutable, action) => {
  return state.merge({
    resetUserPasswordFetching: true,
    email: action.email,
    resetUserPasswordResponse: null,
    resetUserPasswordError: null
  })
}
export const resetUserPasswordSuccess = (state: Immutable, action) => {
  return state.merge({
    resetUserPasswordFetching: false,
    resetUserPasswordResponse: action.resetUserPasswordResponse,
    resetUserPasswordError: null
  })
}
export const resetUserPasswordFailure = (state: Immutable, action) => {
  return state.merge({
    resetUserPasswordFetching: false,
    resetUserPasswordError: action.resetUserPasswordError
  })
}

/*---------- confirmResetUserPassword --------*/
export const requestConfirmResetUserPassword = (state: Immutable, action) => {
  return state.merge({
    confirmResetUserPasswordFetching: true,
    confirmData: action.confirmData,
    confirmResetUserPasswordError: null,
    confirmResetUserPasswordResponse: null
  })
}
export const confirmResetUserPasswordSuccess = (state: Immutable, action) => {
  return state.merge({
    confirmResetUserPasswordFetching: false,
    confirmResetUserPasswordResponse: action.confirmResetUserPasswordResponse,
    confirmResetUserPasswordError: null
  })
}
export const confirmResetUserPasswordFailure = (state: Immutable, action) => {
  return state.merge({
    confirmResetUserPasswordFetching: false,
    confirmResetUserPasswordError: action.confirmResetUserPasswordError
  })
}

/*---------- customerRegister --------*/
export const requestCustomerRegister = (state: Immutable, action) => {
  return state.merge({
    customerRegisterFetching: true,
    customeReq: action.customerReq,
    customerRegisterError: null
  })
}
export const customerRegisterSuccess = (state: Immutable, action) => {
  return state.merge({
    customerRegisterFetching: false,
    customerRegisterResponse: action.customerRegisterResponse,
    customerRegisterError: null
  })
}
export const customerRegisterFailure = (state: Immutable, action) => {
  return state.merge({
    customerRegisterFetching: false,
    customerRegisterError: action.customerRegisterError
  })
}

/*---------- updateCustomerProfile --------*/
export const requestUpdateCustomerProfile = (state: Immutable, action) => {
  return state.merge({
    updateCustomerProfileFetching: true,
    customerProfileReq: action.customerProfileReq,
    updateCustomerProfileResponse: null,
    updateCustomerProfileError: null
  })
}
export const updateCustomerProfileSuccess = (state: Immutable, action) => {
  return state.merge({
    updateCustomerProfileFetching: false,
    updateCustomerProfileResponse: action.updateCustomerProfileResponse,
    updateCustomerProfileError: null
  })
}
export const updateCustomerProfileFailure = (state: Immutable, action) => {
  return state.merge({
    updateCustomerProfileFetching: false,
    updateCustomerProfileError: action.updateCustomerProfileError
  })
}

/*---------- saveCookie --------*/
export const requestSaveCookie = (state: Immutable) => {
  return state.merge({
    cookie: true
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- login --------*/
  [Types.REQUEST_LOGIN]: requestLogin,
  [Types.LOGIN_SUCCESS]: loginSuccess,
  [Types.LOGIN_FAILURE]: loginFailure,
  [Types.REQUEST_LOGOUT]: requestLogout,
  [Types.REQUEST_ENABLE_LOGIN_MODAL]: requestEnableLoginModal,

  /*---------- userProfile --------*/
  [Types.REQUEST_USER_PROFILE]: requestUserProfile,
  [Types.USER_PROFILE_SUCCESS]: userProfileSuccess,
  [Types.USER_PROFILE_FAILURE]: userProfileFailure,

  /*---------- externalLogin --------*/
  [Types.REQUEST_EXTERNAL_LOGIN]: requestExternalLogin,
  [Types.EXTERNAL_LOGIN_SUCCESS]: externalLoginSuccess,
  [Types.EXTERNAL_LOGIN_FAILURE]: externalLoginFailure,

  /*---------- register --------*/
  [Types.REQUEST_REGISTER]: requestRegister,
  [Types.REGISTER_SUCCESS]: registerSuccess,
  [Types.REGISTER_FAILURE]: registerFailure,

  /*---------- confirmEmail --------*/
  [Types.REQUEST_CONFIRM_EMAIL]: requestConfirmEmail,
  [Types.CONFIRM_EMAIL_SUCCESS]: confirmEmailSuccess,
  [Types.CONFIRM_EMAIL_FAILURE]: confirmEmailFailure,

  /*---------- updateUserProfile --------*/
  [Types.REQUEST_UPDATE_USER_PROFILE]: requestUpdateUserProfile,
  [Types.REQUEST_CLEAR_UPDATE_USER_PROFILE_STATUS]: requestClearUpdateUserProfileStatus,
  [Types.UPDATE_USER_PROFILE_SUCCESS]: updateUserProfileSuccess,
  [Types.UPDATE_USER_PROFILE_FAILURE]: updateUserProfileFailure,

  /*---------- resetUserPassword --------*/
  [Types.REQUEST_RESET_USER_PASSWORD]: requestResetUserPassword,
  [Types.RESET_USER_PASSWORD_SUCCESS]: resetUserPasswordSuccess,
  [Types.RESET_USER_PASSWORD_FAILURE]: resetUserPasswordFailure,

  /*---------- confirmResetUserPassword --------*/
  [Types.REQUEST_CONFIRM_RESET_USER_PASSWORD]: requestConfirmResetUserPassword,
  [Types.CONFIRM_RESET_USER_PASSWORD_SUCCESS]: confirmResetUserPasswordSuccess,
  [Types.CONFIRM_RESET_USER_PASSWORD_FAILURE]: confirmResetUserPasswordFailure,

  /*---------- customerRegister --------*/
  [Types.REQUEST_CUSTOMER_REGISTER]: requestCustomerRegister,
  [Types.CUSTOMER_REGISTER_SUCCESS]: customerRegisterSuccess,
  [Types.CUSTOMER_REGISTER_FAILURE]: customerRegisterFailure,

  /*---------- updateCustomerProfile --------*/
  [Types.REQUEST_UPDATE_CUSTOMER_PROFILE]: requestUpdateCustomerProfile,
  [Types.UPDATE_CUSTOMER_PROFILE_SUCCESS]: updateCustomerProfileSuccess,
  [Types.UPDATE_CUSTOMER_PROFILE_FAILURE]: updateCustomerProfileFailure,

  /*---------- saveCookie --------*/
  [Types.REQUEST_SAVE_COOKIE]: requestSaveCookie
})



// WEBPACK FOOTER //
// ./src/redux/sagaAuth/sagaAuthRedux.ts